import { SvgIcon, SvgIconProps } from "@mui/material";

export const CustomersIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      aria-label="customers"
    >
      <circle
        cx="12.5"
        cy="11.5"
        r="9.5"
        stroke="#52BB9D"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
      />
      <path
        stroke="#52BB9D"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M15.244 8.655c.008.234.008.469 0 .703a2.747 2.747 0 0 1-2.744 2.648v0a2.747 2.747 0 0 1-2.744-2.648 9.868 9.868 0 0 1 0-.703A2.747 2.747 0 0 1 12.5 6.006v0a2.747 2.747 0 0 1 2.744 2.649v0Z"
        clip-rule="evenodd"
      />
      <path
        stroke="#52BB9D"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.2"
        d="M7.993 16.006a10.625 10.625 0 0 1 9 0"
      />
    </svg>
    ;
  </SvgIcon>
);
